
export async function sendJson(method, url, json) {
  const res = await fetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });
  return res.json();
}

export async function getJson(url) {
  const res = await fetch(url, {
    headers: {
      Accept: 'application/json',
    },
  });
  return res.json();
}
